import { render, staticRenderFns } from "./NewEditDaily.vue?vue&type=template&id=15c3da06&scoped=true&"
import script from "./NewEditDaily.vue?vue&type=script&lang=js&"
export * from "./NewEditDaily.vue?vue&type=script&lang=js&"
import style0 from "./NewEditDaily.vue?vue&type=style&index=0&id=15c3da06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3da06",
  null
  
)

export default component.exports